import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  trackView,
  transformPathToAnalyticFormat,
} from 'utils/functions/analytics';

export function useTrackRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    trackView({
      pagename: transformPathToAnalyticFormat(pathname),
    });
  }, [pathname]);
}

/**
 * Tracks the view on very first time the component is rendered
 * on the virtual DOM.
 * @param data analytics data.
 * @param triggerViewSwitch Triggers a view the very first time
 * 'triggerViewSwitch' is 'true'.
 * N.B. It won't track further views if data changes.
 */
export function useTrackViewOnce(
  data: Record<string, string>,
  triggerViewSwitch: boolean,
) {
  // We want to invoke the analytics events only once.
  const dataRef = useRef<Record<string, string>>(data);
  const hasTrackedRef = useRef<boolean>(false);

  // Manually update 'dataRef', if we have not tracked yet.
  if (!hasTrackedRef.current && dataRef.current !== data) {
    dataRef.current = data;
  }

  useEffect(() => {
    if (triggerViewSwitch && !hasTrackedRef.current) {
      // Update ref to prevent further updates.
      hasTrackedRef.current = true;

      trackView(dataRef.current);
    }
  }, [triggerViewSwitch]);
}
